export const getReferralsSelect = (state) => state.referral.myReferrals;